class FormatedTextArea
  constructor: (@container) ->
    formated = @
    @container.find("textarea").keyup (e)->
      formated.format_value(this)

    @container.find("textarea").change (e)->
      formated.format_value(this)

  format_value: (target) ->
    rows = $(target).val().split("\n")
    parse_rows = []
    i=0
    while i < 6 && i < rows.length
      parse_rows[i] = rows[i].substring(0, 39)
      i++
    $(target).val(parse_rows.join("\n"))

$(document).ready ->
  $("*[data-behavior=FormatedTextArea]").each ->
    new FormatedTextArea($(@))
